module.exports = __webpack_public_path__ + "img/logo_nd.8830ca62.png";